import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import cn from 'classnames';

import { BaseComponent } from '../../../../../../components/BaseComponent';
import { HBox, VBox } from '../../../../../../components/Box';
import CardComponent from '../../../../../../containers/App/Components/Card/Card';
import LoadingCard from '../../../../../../containers/App/Components/LoadingCard/LoadingCard';
import { RegplateLabel } from '../../../RegplateLabel';

import { selectNewOrder } from '../../../../selectors';
import { formatCurrency } from '../../../../../../utils/string';
import { getDate, getImgUrlExterior } from '../../../../helpers';

import s from './OutgoingOrderVehicleCard.module.css';
import { REQUEST_AMOUNTS_CALCULATIONS } from '../../../../../Invoices/constants';
import { selectWork } from '../../../../../Api/selectors';
import { VEHICLE_TAX_TYPE } from '../../../../constants';
import { Loader } from '../../../../../../components/Loader';

const STATE = {
  priceDetails: null,
};

/* eslint-disable react/prefer-stateless-function */
class OutgoingOrderVehicleCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  showDetails(productId) {
    if (!this.state?.[`price_details_${productId}`]) {
      return this.setState({ [`price_details_${productId}`]: true });
    }
    return this.setState({ [`price_details_${productId}`]: false });
  }

  renderPriceDetails(priceDetails) {
    const title = this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW ? 'VAT vehicle: ' : 'Marge vehicle: ';
    const financialAmounts =
      this.props.vehicle?.tax_type === VEHICLE_TAX_TYPE.BTW
        ? ['financial_price_excl_vat_excl_bpm', 'outgoing_rest_bpm', 'vat_amount', 'financial_price_incl_vat_bpm']
        : ['financial_price_marge_excl_bpm', 'outgoing_rest_bpm', 'financial_price_marge_incl_bpm'];

    return (
      <VBox>
        <HBox className={s.cardItem}>
          <h6 className={s.gridCardItem}>
            <strong>{title}</strong>
          </h6>
        </HBox>
        {financialAmounts?.map(prop => {
          return (
            <HBox key={prop} className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl(`vehicle.property.${prop}`)}</h6>
              {this.props.workCalc ? (
                <Loader small />
              ) : (
                <h6 className={s.gridCardItem}>{formatCurrency(this.props.values?.priceDetails?.[prop])}</h6>
              )}
            </HBox>
          );
        })}
      </VBox>
    );
  }

  renderCard = vehicle => {
    let date = getDate(vehicle.date_first_allowance);

    if (this.props.work) return <LoadingCard />;
    const leftFrontImage = this.state.leftFrontImage || this.props.photos?.[0];

    return (
      <CardComponent
        key={vehicle.id}
        id={`item${vehicle.id}`}
        imgURL={`${
          leftFrontImage?.id
            ? leftFrontImage?.url
            : vehicle?.action_ws2_interior_inspection_done === '1'
            ? `${getImgUrlExterior(vehicle?.helga_id || vehicle?.id, '01')}`
            : `/public/images/placeholder.png`
        }`}
        title={<div className={s.cardTitle}></div>}
      >
        <div className={cn('text-muted')}>
          <div>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.brand_name')}</h6>
              <h6 className={s.gridCardItem}>{vehicle.brand_name}</h6>
            </HBox>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.model_name')}</h6>
              <h6 className={s.gridCardItem}>{vehicle.model_name}</h6>
            </HBox>
            <HBox right className={s.cardItem}>
              {/* <p>{this.lbl('vehicle.property.regplate')}</p> */}
              <h6 className={s.gridCardItem}>{vehicle.model_info}</h6>
            </HBox>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.regplate')}</h6>
              <h6 className={s.gridCardItem}>{<RegplateLabel regplate={vehicle.regplate} width="80" />}</h6>
            </HBox>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.vin')}</h6>
              <h6 className={s.gridCardItem}>{vehicle.vin}</h6>
            </HBox>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.date_first_allowance')}</h6>
              <h6 className={s.gridCardItem}>{date}</h6>
            </HBox>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.mileage')}</h6>
              <h6 className={s.gridCardItem}>{parseInt(vehicle.mileage || '0').toLocaleString() + ' km'}</h6>
            </HBox>
            <HBox className={s.cardItem}>
              <h6 className={s.gridCardItem}>{this.lbl('vehicle.property.interior_color')}</h6>
              <h6 className={s.gridCardItem}>{vehicle.interior_color}</h6>
            </HBox>
            {this.props.values?.fix_damages && (
              <HBox className={s.cardItem}>
                <h6 className={s.gridCardItem}>{this.lbl('vehicle.order.fix_damages')}</h6>
                <h6 className={s.gridCardItem}>
                  {this.props.values.fix_damages === '1' ? this.lbl('yes') : this.lbl('no')}
                </h6>
              </HBox>
            )}
            <hr style={{ borderBottom: '2px solid rgba(0, 0, 0, 0.8)' }} />
            <HBox className={s.cardItem}>{this.renderPriceDetails()}</HBox>
            <hr />
            <h6>{this.lbl('outgoing_order.products')}</h6>
            {this.props.products.map(([key, val]) => {
              if (!val['incl']) return;
              const name = val?.['editedName'] ? val?.['editedName'] : val?.['costType'];
              return (
                <VBox key={val?.id}>
                  <HBox>
                    <HBox className={s.cardItem} key={val?.['costType']}>
                      <h6 className={s.gridCardItem}>
                        <strong>{name}</strong>
                      </h6>
                      <h6 className={s.gridCardItem}>{formatCurrency(val?.['cost'])}</h6>
                    </HBox>
                  </HBox>
                </VBox>
              );
            })}
          </div>
        </div>
      </CardComponent>
    );
  };

  render() {
    return this.renderCard(this.props.vehicle);
  }
}

OutgoingOrderVehicleCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewOrder(),
    workCalc: selectWork(REQUEST_AMOUNTS_CALCULATIONS),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const OutgoingOrderVehicleCard = compose(withConnect, withRouter, injectIntl)(OutgoingOrderVehicleCardComp);
